import axios from "axios";
import { CHECKVOUCHERCODE } from "../index";

export const checkVoucherApi = (postData) => {
  return axios.post(CHECKVOUCHERCODE, postData);
};
